import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {TimeZonesInterface} from "../models/settings/TimeZonesInterface";
import { PropertiesInterface } from "@api/models/settings/PropertiesInterface";

export class SettingRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    timezones(): Promise<TimeZonesInterface> {
        return this.client.get('/settings')
            .then(({data}) => {
                return (data['timeZones'] || {} as TimeZonesInterface);
            })
    }

    getLanguages(): Promise<string[]> {
        return this.client.get('/settings')
            .then(({ data }) => {
                return (data['languages'] || []);
            })
    }

    getProperties(): Promise<PropertiesInterface> {
        return this.client.get('/settings')
            .then(({ data }) => {
                return data['properties'] || {};
            })
    }
}